/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IPayPeriods, PayPeriodStatus } from 'types';
import { isStalePayPeriodError, payPeriodKey } from 'utils/payPeriods';
import { IPayPeriodsState } from '../../types';
import { PayPeriods } from './types';

const initialState: IPayPeriodsState | null = null;

const setSitePayPeriods = (state: IPayPeriodsState | null, orgId: string, siteId: string, sitePayPeriods: IPayPeriods): IPayPeriodsState => ({
  ...state,
  [orgId]: { ...state?.[orgId], [siteId]: sitePayPeriods },
});

export const payPeriodsReducer: Reducer<IPayPeriodsState | null> = (state = initialState, action) => {
  switch (action.type) {
    case PayPeriods.GET_PAY_PERIODS_SUCCESS: {
      const { siteId, orgId, response } = action.payload;
      const existing = state?.[orgId]?.[siteId]?.data || [];

      // Newest first: each page is older than the one before it, so it appends.
      const data = [...existing, ...response.data];

      return setSitePayPeriods(state, orgId, siteId, { ...response, data });
    }
    case PayPeriods.UPDATE_PAY_PERIOD_STATUS_SUCCESS: {
      const { siteId, orgId, response } = action.payload;
      const sitePayPeriods = state?.[orgId]?.[siteId];
      if (!sitePayPeriods) return state;

      // Patch only the changed row; the rest of the list is untouched.
      const { status, closedAt, closedBy, reopenedAt, reopenedBy } = response;
      const closure = { status, closeable: status !== PayPeriodStatus.CLOSED, closedAt, closedBy, reopenedAt, reopenedBy };
      const key = payPeriodKey({ start: response.startDate, end: response.endDate });
      const data = sitePayPeriods.data.map((period) => (payPeriodKey(period) === key ? { ...period, ...closure } : period));

      return setSitePayPeriods(state, orgId, siteId, { ...sitePayPeriods, data });
    }
    case PayPeriods.UPDATE_PAY_PERIOD_STATUS_FAIL: {
      // The loaded periods are stale: drop them so the screens reload them.
      return isStalePayPeriodError(action.payload) ? initialState : state;
    }
    default: {
      return state;
    }
  }
};
